export const POSITION_END = 'POSITION_END'